import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import AdminDashboardStatistics from "./AdminDashboardStatistics";
import { AdminDashboardViewByPerson } from "./AdminDashboardViewByPerson";

export default function Dashboard() {
    const { user } = useAuth();
    const [activeTab, setActiveTab] = useState("statistics");

    // Show for both owner and manager
    if (user?.role !== "owner" && user?.role !== "manager") {
        return null;
    }

    return (
        <>
            <div className="mb-4 border-b border-gray-200">
                <nav className="flex -mb-px">
                    <button
                        onClick={() => setActiveTab("statistics")}
                        className={`py-2 px-4 font-medium text-sm ${
                            activeTab === "statistics"
                                ? "border-b-2 border-blue-500 text-blue-600"
                                : "text-gray-500 hover:text-gray-700 hover:border-gray-300"
                        }`}
                    >
                        Statistika
                    </button>
                    <button
                        onClick={() => setActiveTab("view_by_person")}
                        className={`ml-8 py-2 px-4 font-medium text-sm ${
                            activeTab === "view_by_person"
                                ? "border-b-2 border-blue-500 text-blue-600"
                                : "text-gray-500 hover:text-gray-700 hover:border-gray-300"
                        }`}
                    >
                        Pregled po osebi
                    </button>
                </nav>
            </div>
            {activeTab === "statistics" && <AdminDashboardStatistics />}
            {activeTab === "view_by_person" && <AdminDashboardViewByPerson />}
        </>
    );
}
